module.exports = __webpack_public_path__ + "assets/img/mastercard.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/mastercard.png
// module id = 122
// module chunks = 0